import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import cclogo from '../../images/cclogo.png'
import { AuthContext } from '../AuthProvider'
import { Menu, Image, Sidebar, Icon } from 'semantic-ui-react'
import * as adminRoutes from '../Admin/routes'
import PropTypes from 'prop-types'

class Nav extends Component {
  state = {
    menuVisible: false
  }

  static propTypes = {
    children: PropTypes.node
  }

  toggleMenu = () => {
    this.setState(
      state => ({
        menuVisible: !state.menuVisible
      }),
      () => {
        if (this.state.menuVisible) {
          document.body.onclick = this.toggleMenu
        } else document.body.onclick = null
      }
    )
  }

  render() {
    const userTypeSidebarItems = {
      superAdmin: [
        <Menu.Item key={0}>
          <Icon name="group" size="huge" />
          <h1>Admins</h1>
        </Menu.Item>
      ],
      admin: [
        <Menu.Item as={Link} to={adminRoutes.TEAM} key={0}>
          <Icon name="group" size="huge" />
          <h1>My Team</h1>
        </Menu.Item>,
        <Menu.Item as={Link} to={adminRoutes.GAMES} key={1}>
          <Icon name="clipboard" size="huge" />
          <h1>My Games</h1>
        </Menu.Item>
      ]
    }
    return (
      <AuthContext.Consumer>
        {({ user, signOut }) => (
          <Menu
            color="orange"
            inverted
            style={{
              padding: 20
            }}
          >
            <Menu.Item>
              <Image src={cclogo} size="tiny" />
            </Menu.Item>
            {this.props.children}
            {user !== null && (
              <Fragment>
                <Menu.Item position="right" onClick={this.toggleMenu}>
                  <Icon name="sidebar" size="huge" />
                </Menu.Item>
                <Sidebar
                  as={Menu}
                  visible={this.state.menuVisible}
                  direction="right"
                  animation="overlay"
                  width="wide"
                  inverted
                  vertical
                >
                  {userTypeSidebarItems[user.type]}
                  <Menu.Item key={1} onClick={signOut}>
                    <Icon name="log out" size="huge" />
                    <h1>Sign Out</h1>
                  </Menu.Item>
                </Sidebar>
              </Fragment>
            )}
          </Menu>
        )}
      </AuthContext.Consumer>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.jsx